import React from 'react';
import { Formik, Form, Field } from 'formik';
import Radio from '@tds/core-radio';
import FieldLocationInput from '../form/fields/fieldLocationInput';
import { getStepTwoSchema } from './schema';
import { useTranslationsContext } from '../context/TranslationsContext';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import { channelFields } from '../utils/index';

const StepTwo = ({
  onSubmit,
  stepData: {
    serviceAddress,
    isMultiSuite,
    businessType,
    propertyRoom,
    noOfEmployees
  },
  role
}) => {
  const translations = useTranslationsContext();
  const pageKey = "businessInformation";

  const {
    REFERRALS: {
      stepTwo: { labels, errorLabels }
    }
  } = translations;
  const [yes, no] = labels.IsMultiSuiteOptions;
  const [hotel, multiDewelingUnits, seniorLiving] = labels.businessTypeOptions;
  const [oneToFifteen, sixToTwenty, twentyOnePlus] = labels.propertyRoomOptions;
  const [
    oneToThirty,
    thirtyToHundred,
    hundredPlus
    // oneToTen,
    // elevenToTwentyNine,
    // thirtyToFourtyNine,
    // fiftyPlus,
  ] = labels.noOfEmployeesOptions;
  const handleOnChangeNoValueMultiSuite = (values) => {
    // clear businessType & propertyRoom values if isMultiSuite = No
    values.businessType = ""
    values.propertyRoom = ""
  }

  return (
    <div className='layout-container'>
    <Formik
      validationSchema={getStepTwoSchema(errorLabels, isMultiSuite)}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmit}
      initialValues={{
        serviceAddress: serviceAddress || '',
        isMultiSuite: (!channelFields(pageKey) ? no : ''),
        businessType: businessType || '',
        propertyRoom: propertyRoom || '',
        noOfEmployees: noOfEmployees || ''
      }}
    >
      {({ errors, touched, values, setFieldValue, handleChange }) => (
        <Form>
          <div className="main-content-form-headers" style={{ marginTop: 20 }}>
            <span className="select-placeholder">{labels.serviceAddress}*</span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${errors.serviceAddress && touched.serviceAddress ? 'error' : ''
              }`}
          >
            <FieldLocationInput
              data={{
                name: 'serviceAddress',
                type: 'Address',
                maxLength: 100,
                minLength: 10,
                value: values.serviceAddress,
                onChange: handleChange,
                readonly: false,
                disabled: false,
                isSameAs: false
              }}
            />
            <>
              <div className="error_messages">
                <span className="frg-body-font-14px">
                  {errors.serviceAddress}
                </span>
              </div>
              <div id="username_error_icon" className="error_messages_icon">
                <img src={ErrorIcon} alt="error_icon" />
              </div>
            </>
          </div>
          {channelFields(pageKey) &&
            <>
              <div className="main-content-form-headers">
                <span className="select-placeholder">{labels.isMultiSuite}*</span>
              </div>
              <div
                style={{ position: 'relative' }}
                className={`input-container ${errors.isMultiSuite && touched.isMultiSuite ? 'error' : ''
                  }`}
              >
                <label style={{ display: 'flex' }}>
                  <Field
                    name="isMultiSuite"
                    type="radio"
                    as={Radio}
                    value="Yes"
                    className="select-style"
                  />{' '}
                  {yes}
                </label>
                <label
                  style={{ display: 'flex' }}
                  onChange={() => handleOnChangeNoValueMultiSuite(values)}
                >
                  <Field
                    name="isMultiSuite"
                    type="radio"
                    as={Radio}
                    value="No"
                    className="select-style"
                  />{' '}
                  {no}
                </label>
                <label>
                  <div>
                    <span className="frg-body-font-16px warning-error-message">
                      {errors.isMultiSuite}
                    </span>
                  </div>
                </label>
              </div>
            </>
          }
          {values.isMultiSuite === yes && (
            <>
              <div
                className="main-content-form-headers"
              >
                <span className="select-placeholder">
                  {labels.businessType}*
                </span>
              </div>
              <div
                style={{ position: 'relative' }}
                className={`input-container ${errors.businessType && touched.businessType ? 'error' : ''
                  }`}
              >
                <label style={{ display: 'flex' }}>
                  <Field
                    name="businessType"
                    type="radio"
                    as={Radio}
                    value={hotel}
                    className="select-style"
                  />{' '}
                  {hotel}
                </label>
                <label style={{ display: 'flex' }}>
                  <Field
                    name="businessType"
                    as={Radio}
                    type="radio"
                    value={multiDewelingUnits}
                    className="select-style"
                  />{' '}
                  {multiDewelingUnits}
                </label>
                <label style={{ display: 'flex' }}>
                  <Field
                    name="businessType"
                    as={Radio}
                    type="radio"
                    value={seniorLiving}
                    className="select-style"
                  />{' '}
                  {seniorLiving}
                </label>
                <label>
                  <div>
                    <span className="frg-body-font-16px warning-error-message">
                      {errors.businessType}
                    </span>
                  </div>
                </label>
              </div>
            </>
          )}
          {values.isMultiSuite === yes && values.businessType && (!channelFields(pageKey)) && (
            <>
              <div
                className="main-content-form-headers"
              >
                <span className="select-placeholder">
                  {labels.propertyRoom}
                </span>
              </div>
              <div
                style={{ position: 'relative' }}
                className={`input-container ${errors.propertyRoom && touched.propertyRoom ? 'error' : ''
                  }`}
              >
                <label style={{ display: 'flex' }}>
                  <Field
                    name="propertyRoom"
                    type="radio"
                    as={Radio}
                    value={oneToFifteen}
                    className="select-style"
                  />{' '}
                  {oneToFifteen}
                </label>
                <label style={{ display: 'flex' }}>
                  <Field
                    name="propertyRoom"
                    as={Radio}
                    type="radio"
                    value={sixToTwenty}
                    className="select-style"
                  />{' '}
                  {sixToTwenty}
                </label>
                <label style={{ display: 'flex' }}>
                  <Field
                    name="propertyRoom"
                    as={Radio}
                    type="radio"
                    value={twentyOnePlus}
                    className="select-style"
                  />{' '}
                  {twentyOnePlus}
                </label>
                <label>
                  <div>
                    <span className="frg-body-font-16px warning-error-message">
                      {errors.propertyRoom}
                    </span>
                  </div>
                </label>
              </div>
            </>
          )}
          {!channelFields(pageKey) && (
            <>

              <div className="main-content-form-headers">
                <span className="select-placeholder">{labels.noOfEmployees}</span>
              </div>
              <div
                style={{ position: 'relative' }}
                className={`input-container ${errors.noOfEmployees && touched.noOfEmployees ? 'error' : ''
                  }`}
              >
                <label style={{ display: 'flex' }}>
                  <Field
                    name="noOfEmployees"
                    type="radio"
                    as={Radio}
                    value={oneToThirty}
                    className="select-style"
                  />{' '}
                  {oneToThirty}
                </label>
                <label style={{ display: 'flex' }}>
                  <Field
                    name="noOfEmployees"
                    as={Radio}
                    type="radio"
                    value={thirtyToHundred}
                    className="select-style"
                  />{' '}
                  {thirtyToHundred}
                </label>
                <label style={{ display: 'flex' }}>
                  <Field
                    name="noOfEmployees"
                    as={Radio}
                    type="radio"
                    value={hundredPlus}
                    className="select-style"
                  />{' '}
                  {hundredPlus}
                </label>
                {/* <label style={{ display: 'flex' }}>
            <Field
              name="noOfEmployees"
              as={Radio}
              type="radio"
              value={thirtyToFourtyNine}
              className="select-style"
            />{' '}
            {thirtyToFourtyNine}
          </label>
          <label style={{ display: 'flex' }}>
            <Field
              name="noOfEmployees"
              as={Radio}
              type="radio"
              value={fiftyPlus}
              className="select-style"
            />{' '}
            {fiftyPlus}
          </label> */}
                <label>
                  <div>
                    <span className="frg-body-font-16px warning-error-message">
                      {errors.noOfEmployees}
                    </span>
                  </div>
                </label>
              </div>
            </>
          )}

          <button className="frg-button color-green" type="submit" id='referrals'>
            Next
          </button>
        </Form>
      )}
    </Formik>
    </div>
  );
};

export default StepTwo;
